import * as React from 'react';
import { Button } from 'primereact/button';
import { Redirect } from 'react-router-dom';
import mainLogo from '../../images/logo-edenred.png';
import BlanquearClave from './components/BlanquearClave';
import { useEffect, useState } from 'react';
import { getAceptar , requestMfa} from './services/login.service';
import ReCAPTCHA from "react-google-recaptcha";
import { googleResponseCaptcha } from '../shared/services/googlecaptcha.service';
import { HttpStatusCode } from 'axios';
import { PrivateRoutes } from '../shared/models/routes';
import { STORAGE_LOCAL } from '../shared/models/storages';
import CountdownTimer from '../shared/components/CountdownTimer/CountdownTimer';
import { RECAPTCHA_ACTION_LOGIN, RECAPTCHA_ACTION_PASSWORD_RESET } from '../shared/utilitties/constants';
import LoginMFA from './components/LoginMFA';
interface Props {
    enviarLogeo: Function
}

const LoginError = {
    General: 0,
    UserOrPass: 1,
    ExpiredPass: 2,
    Captcha: 3,
    RateLimit: 429,
};

const Login = (props: Props) => {
    const [isRedirected, setIsRedirected] = useState("false");
    const captchaRef = React.useRef<ReCAPTCHA>(null)
    const [usuarioValido,setUsuarioValido] = useState(false);
    const[captchaValido,setCaptchaValido] = useState<boolean|null>(null);
    const ManyRequests = HttpStatusCode.TooManyRequests
    const [user, setUser] = useState({
        usuario: '',
        clave: '',
        userValidation: 0,
        token: ''
    })
    const [state, setState] = useState({
        redirect: false,
        loading: false,
        url: '',
        popup: false,
        requestMfa: true,
        authorized: false,
        error: {
            code: LoginError.General,
            message: '',
        },
        token: '',
    })
    
    const [requestData,setRequestData] = useState({message:"",details:"",ms:0})
    

    useEffect(() => {
        var a = window.sessionStorage.getItem(STORAGE_LOCAL.IS_REDIRECTED) || "false"
        setIsRedirected(a);
        window.sessionStorage.removeItem(STORAGE_LOCAL.IS_REDIRECTED);
    }, []);

    const onchangeCaptcha = async()=> {
        if(captchaRef?.current?.getValue()){
            setCaptchaValido(true)
        }

    }

    async function aceptar(e:any) {
        e.preventDefault();

        if(user.usuario == '' || user.clave == ''){
            setState({ 
                ...state,
                error: {
                    code: LoginError.General,
                    message: "Debes completar los campos",
                } 
            })
            return;
        }

        var captchaOk = await validCaptcha(RECAPTCHA_ACTION_LOGIN)
        if (!captchaOk) {
          return;
        }
        
        var comercios = { Usuario: user.usuario, Clave: user.clave };
        const { data, status } = await getAceptar(comercios);

        if (status === HttpStatusCode.TooManyRequests) {
            setState({ 
                ...state,  
                error: {
                    code: LoginError.RateLimit,
                    message: "Too Many Requests",
                }, 
                loading: false,
            });
            setRequestData(data);
            setUsuarioValido(false);
            return;
        }
        
        if (data.authorized === true && data.requireMfa  === true) {
               
                setState({
                    ...state,
                    url: data.url, 
                    requestMfa: true,
                    redirect: false, 
                    loading: false,
                    token: data.token,
                    authorized: data.authorized
                });
                return;
                }

        if ( data.authorized === true && data.requireMfa  === false) {
            window.localStorage.setItem(STORAGE_LOCAL.TOKEN, data.token)
            props.enviarLogeo(true, true)
            setState({ 
                ...state, 
                url: data.url, 
                redirect: true, 
                loading: false, 
                token: data.token,
                authorized: data.authorized
            });
            return;
        }

        let error = {
            code: LoginError.UserOrPass,
            message: "Usuario o Clave incorrecta.",
        };
        if (data.resetted === true) {
            error = {
                code: LoginError.ExpiredPass, 
                message: data.data,
            }         
        }

        setState({ 
            ...state, 
            error, 
            loading: false, 
        });
        setUsuarioValido(false);
  }

  const validCaptcha = async (action: string) => {
    setState({ ...state, loading: true });

    return new Promise((resolve) => {
        grecaptcha.enterprise.ready(async () => {
            const token = await grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY!, { action: action });
            var recapthaToken = {
                token: token,
                action: action,
                siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY!
            };            
            const response = await googleResponseCaptcha(recapthaToken);            
            const captcha_status = response.data.success ? HttpStatusCode.Ok : HttpStatusCode.InternalServerError;            
            if (captcha_status !== HttpStatusCode.Ok) {
                setUsuarioValido(false);
                setCaptchaValido(false);
                setState({
                    ...state,
                    loading: false,
                    error: {
                        code: LoginError.Captcha,
                        message: "No se pudo validar el captcha. Por favor, inténtalo nuevamente.",
                    }
                });
                resolve(false);
            } else {
                setCaptchaValido(true);
                setUsuarioValido(true);
                resolve(true);
            }
        });
    });        
  }

    const onClickBlanquearClave = async () => {
        if (user.usuario.length != 0) {
            var captchaOk = await validCaptcha(RECAPTCHA_ACTION_PASSWORD_RESET)
            if (captchaOk){ 
                if (state.popup == false) {
                    setState({ ...state, popup: true });
                } else {
                    setState({ ...state, popup: false });
                }
                setUser({ ...user, userValidation: 0 });
            }
        } else {
            setUser({ ...user, userValidation: 1 });
        }
    }

    function handleBlanquearClave() {
        setState({ ...state, popup: false });
    }

    if (state.redirect) {
        return (
            <Redirect to={PrivateRoutes.HOME} />
        )
    };

    return (
        <div className="d-flex">
            <div className="login-left-size">
                <div className="portal-commerce">
                    <p><span>Portal de</span> Comercios</p>
                </div>
                <figure>
                    <img className="main-logo" src={mainLogo} alt="Edenred" />
                </figure>
            </div>
            <div className="login-right-size">


                <div className="wrapper">

                    <figure>
                        <img className="mobile-logo" src={mainLogo} alt="Edenred" />
                    </figure>
                    
                    <div className="login-message">
                        <p><span className="login-welcome">¡Es bueno verte de nuevo!</span></p>
                        <p>En este portal de acceso exclusivo podrás gestionar tu cuenta, monitorear los pagos y acceder a todas las ventajas y beneficios que te ofrece Edenred por ser parte de su red.</p>
                    </div>

                        {state.requestMfa && state.authorized? (
                        <LoginMFA
                            userId={user.usuario}
                            onSuccess={() => {
                            window.localStorage.setItem(STORAGE_LOCAL.TOKEN, state.token);
                            props.enviarLogeo(true, true);
                            setState({ ...state, redirect: true });
                            }}
                            onResend={() => requestMfa( user.usuario )}
                        />
                        ) : (
                        <>

                    <div>
                    
                    <form className="formLoginEdenred" onSubmit={(event) => aceptar(event)}>
                        <input type="submit" hidden/>
                        <div className="login-input">
                            {isRedirected === 'true' &&
                                <div className='p-error block' style={{paddingBottom: "30px", fontWeight:'700'}}>Cerramos tu sesión por inactividad.</div>}
                            <div className="d-flex align-items-center justify-content-center">
                                <i className="pi pi-user"></i>
                                <input 
                                    disabled={state.error.code == LoginError.RateLimit} 
                                    value={state.error.code == LoginError.RateLimit ? '' : user.usuario} 
                                    type="text" id="userID" 
                                    autoComplete='on' 
                                    onChange={(e) => setUser({ ...user, usuario: e.target.value })} 
                                    placeholder="Usuario" />
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <i className="pi pi-lock"></i>
                                <input 
                                    disabled={state.error.code == LoginError.RateLimit} 
                                    value={state.error.code == LoginError.RateLimit ? '' : user.clave} 
                                    type="password" 
                                    autoComplete='on' 
                                    id="passwordID" 
                                    onChange={(e) => setUser({ ...user, clave: e.target.value })} 
                                    placeholder="Contraseña" />
                            </div>
                            <div> 
                                {   
                                    !usuarioValido
                                    && state.error.code !== LoginError.RateLimit &&
                                    captchaValido === false
                                    && <div className='error-captcha p-error block'>No se pudo validar el captcha. Por favor, inténtalo nuevamente.</div>                                    
                                }
                                {
                                    !state.loading &&
                                    <Button 
                                        label={state.error.code === LoginError.RateLimit ? requestData.message :"INGRESAR"} 
                                        type="button" 
                                        disabled={state.error.code === LoginError.RateLimit || state.error.code == LoginError.ExpiredPass} 
                                        className="btn btn-aceptar btn-block" 
                                        style={state.error.code === LoginError.RateLimit ? {color:'#edf0f5',borderColor:'#636e72',backgroundColor:'#636e72',fontSize:'0.8vw'}:{}} 
                                        onClick={(event) => aceptar(event)} /> 
                                        
                                }
                                {
                                    state.loading  &&
                                    <div className="loading-login">
                                        <span className="spinner-border" role="status"></span>
                                        <p className="d-block mt-3">Cargando</p>
                                    </div>
                                }
                                {   
                                    (
                                        state.error.code == LoginError.UserOrPass || 
                                        state.error.code == LoginError.ExpiredPass
                                    ) && 
                                    <span className="d-block mt-3 p-error block" style={{fontWeight:'bold'}}>{state.error.message}</span>
                                }
                                {
                                    state.error.code == LoginError.RateLimit && 
                                    <>
                                        <span className="d-block mt-3 p-error block" style={{fontWeight:'bold'}}>{requestData.details}</span> 
                                        <div className="p-d-flex p-ai-center p-jc-center">
                                            <CountdownTimer targetDate={ new Date().getTime() + requestData.ms} rateLimit={true} /> 
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </form>
                    {
                        state.error.code !== LoginError.RateLimit && 
                        <div className="login-reset">
                            {!state.loading && <a onClick={() => onClickBlanquearClave()}>Olvidé mi contraseña</a>}
                            {state.popup && <BlanquearClave close={() => handleBlanquearClave()} usuario={user.usuario} />}
                            {(user.userValidation == 1 ? <span className="d-block mt-3">Ingrese el campo Usuario y luego de clic en "Olvidé mi contraseña"</span> : null)}
                        </div>
                    }
                    </div>  
                    </>   
                        )}


                </div>
            </div>
        </div>
    );

}

export default Login;